import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';





Vue.config.productionTip = false
Vue.use(ElementUI);

import Vant from 'vant';
import 'vant/lib/index.css';

import { Form } from 'vant';
import { Field } from 'vant';

Vue.use(Vant);
Vue.use(Form);
Vue.use(Field);

//mqtt地址
Vue.prototype.$mqttUrl = 'wss://mqttv3-wss.endotop.com:8094/mqtt';
// Vue.prototype.$mqttUrl = 'ws://118.195.149.205:8093/mqtt';

//mqtt参数
Vue.prototype.$mqttOptions = {
	clean: true,
	connectTimeout: 4000,
	clientId: 'vue_mqtt_client_' + Math.random().toString(16).substr(2, 8),
	username: 'uniapp', // 如果需要认证，请填写
	password: '123456', // 如果需要认证，请填写
}
//mqtt实例
Vue.prototype.$mqttClient = 11;



//枚举
//直播宣传视频状态
Vue.prototype.$enumH5PlayStatus = {
	VIDEO: 1, //宣传视频
	LIVE: 2 //直播
}

//直播状态
Vue.prototype.$enumLiveStatus = {
	INIT: 1, //初始化
	PLAYING: 2, //直播中
	END: 3, //结束
	TEST: 4 //测试
}


let vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
export default vm; // 将 main.js 中的 Vue 实例暴露出去